class LokasiEntity {
  id: number;
  lokasi: string;

  constructor(object: {
    id: number;
    lokasi: string;
  }) {
    this.id = object.id;
    this.lokasi = object.lokasi;
  }
}

class AddLokasiEntity {
  lokasi?: string;

  constructor(object: {
    lokasi?: string;
  }) {
    this.lokasi = object.lokasi;
  }
}

export { LokasiEntity, AddLokasiEntity };